import { render, staticRenderFns } from "./GameRuleAndPrize.vue?vue&type=template&id=0ca8661a&"
import script from "./GameRuleAndPrize.vue?vue&type=script&lang=js&"
export * from "./GameRuleAndPrize.vue?vue&type=script&lang=js&"
import style0 from "./GameRuleAndPrize.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports